import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import { useLocalStorage } from 'react-use';
import { useHistory, useParams } from 'react-router-dom';
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Container,
  Form,
  Spinner,
  Row,
  Modal,
} from 'react-bootstrap';
import natsort from 'hooks/natsort.js';
import AuditeeProofAnswerInput from '../Widget/Proof/Auditee/Input.js';
import AuditeeProofAnswerFormula from '../Widget/Proof/Auditee/Formula.js';
import AuditeeProofAnswerTable from '../Widget/Proof/Auditee/Table.js';
import AuditorEvaluationAnswerInput from '../Widget/Evaluation/Auditor/Input.js';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';
import { textDecorationUpdate } from '@syncfusion/ej2-react-spreadsheet';
import FormRepository from 'repository/Form.js';

export default function Auditee() {

  const history = useHistory();
  const [auth] = useLocalStorage('authenticated');
  const [swal, setSwal] = useAlert(null);
  const {formId, employeeId} = useParams();

  const [schedule, setSchedule] = useState();
  const [criteria, setCriteria] = useState();
  const [answers, setAnswers] = useState([]);
  const [scores, setScores] = useState([]);
  const [readonly, setReadonly] = useState(false);
  const [formulas, setFormulas] = useState([]);
  const repository = new FormRepository(auth.token);

  const [show, setShow] = useState(false);

  const handleSubmit = async () => {
    try {
      // setShow(true);
      //validate all questions should be answered
      console.log(schedule);
      if (schedule.instrument.FORM_FILE){
        console.log(schedule.instrument.FORM_FILE);
      } else {
        console.log('ini ada isinya');
      }
      const answered = await axios.get(
        `${process.env.REACT_APP_API_HOST}answers`,
        {
          params: {
            expand: `question,form.schedule`,
            FORM_ID: formId,
            all: textDecorationUpdate
          },
          headers: {Authorization: `Bearer ${auth.token}`},
        }
      );

      // validate all input answer should be answer
      if (answered.data.items.find((answer) => (answer.ANSWER_AT === null || answer.ANSWER_DESC === null) && answer.question.QUESTION_TYPE_ID === 1)) {

        setSwal({
          type: TYPES.ERROR,
          payload: {
            title: `Failed!`,
            message: `There is one or more question is not answered, yet!`,
          }
        });
        return false;
      }

      if (
        (schedule.auditee.SCOPE_ID === 1 && schedule.instrument.FORM_FILE) &&
        (!schedule.FORM_FILE &&
        !answered.data.items[0].form.schedule.FORM_FILE)
      ) {
        setSwal({
          type: TYPES.ERROR,
          payload: {
            title: `Failed!`,
            message: `You need to upload Spreadsheet Table before submit.`,
          }
        });

        return false;
      }

      const onSuccessCallback = async () => {
        setShow(true);
        const submission = await axios.post(
          `${process.env.REACT_APP_API_HOST}forms/${formId}/submit`,
          {
            ANSWER_BY: employeeId,
            formulas: formulas,
          },
          {headers: {Authorization: `Bearer ${auth.token}`}},
        );
        // .then(response => {
        //   setShow(false);
        //   console.log(response);
        //   history.push(`/auditee/${employeeId}/audits/${schedule.SCHEDULE_ID}/proofs`);
        // })
        // .catch(error => {
        //   setShow(false);
        //   return console.error('Error:', error.message);
        // });

        const data = {
          SUBMIT_AT: moment().format('DD-MM-YYYY hh:mm:ss'),
          SUBMIT_BY: auth.employee.EMP_ID,
        };
        const response = await repository.update(formId, data);
        setShow(false);
        history.push(`/auditee/${employeeId}/audits/${schedule.SCHEDULE_ID}/proofs`);

      }

      setSwal({
        type: TYPES.CONFIRM,
        payload: {
          title: `You are sure to submit this form?`,
          message: `You won't be able to edit your input after you submit the form.`,
          onSuccess: {
            title: `Success`,
            message: `Submit Success`,
            callback: onSuccessCallback,
          }
        }
      });

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handleClick = async (e) => {
    e.preventDefault();
    return history.push(`/auditee/${auth.employee.EMP_ID}/audits`);
  }

  const handleClickA = async (e) => {
    e.preventDefault();
    return history.push(`/auditee/${auth.employee.EMP_ID}/audits/${schedule.SCHEDULE_ID}/proofs`);
  }

  const fetchForm = async () => {

    try {

      const response = await repository.fetch(formId);

      //check status to readonly mode
      if (response.data.SUBMIT_AT !== null) {
        setReadonly(true);
      }

      setSchedule(response.data.schedule);
      setCriteria(response.data.criteria);
      setAnswers(response.data.answers.sort((a, b) => natsort(a.question.QUESTION_CODE, b.question.QUESTION_CODE)));
      setScores(response.data.schedule.instrument.score.scoreIndices);


    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  useEffect(() => {
    fetchForm();
  }, []);

  return (
    <Container fluid>
      <Modal size='xl' backdrop={false} show={show} onHide={() => setShow(false)}>
        <Modal.Body>
          <h3 style={{color: "red", textAlign: "center"}}>The submission process is in progress, the process takes quite a long time so please wait until it's finished. Please do not be interrupted !!!</h3>
          <h5 style={{textAlign: "center"}}><Spinner style={{ width: "5rem", height: "5rem", }} size="xl" animation="border" variant="danger" role="status"></Spinner></h5>
        </Modal.Body>
      </Modal>
      {swal}
      <Breadcrumb>
        <Breadcrumb.Item onClick={handleClick}>
          Audit
        </Breadcrumb.Item>
        {/* <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
          {schedule && schedule.auditee.department.DEPT_NAME}
        </Breadcrumb.Item> */}
        <Breadcrumb.Item onClick={handleClickA}>
          {schedule && schedule.auditee.department.DEPT_NAME}
        </Breadcrumb.Item>
        <Breadcrumb.Item aria-current="page" active>
          Proof Submission
        </Breadcrumb.Item>
      </Breadcrumb>
      {criteria && (
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title style={{fontWeight:'bold'}} as="h3">{criteria.CRITERIA_CODE}. {criteria.CRITERIA_LABEL}</Card.Title>
              </Card.Header>
              <Card.Body>
                <div style={{whiteSpace: 'pre-wrap', fontSize:'17px'}} dangerouslySetInnerHTML={{__html: criteria.CRITERIA_DESCRIPTION}} />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {answers && schedule && answers.map((answer, key) => {
        switch (answer.question.QUESTION_TYPE_ID) {
          case 1:
            return (
            <AuditeeProofAnswerInput key={key} answer={answer} isReadonly={readonly} >
            </AuditeeProofAnswerInput>
                // <AuditorEvaluationAnswerInput
                //     key={key}
                //     scores={scores}
                //     answer={answer}
                //     isReadonly={readonly}
                //   >
                // </AuditorEvaluationAnswerInput>
            );
          case 2:
            return <AuditeeProofAnswerFormula key={key} answer={answer} formulas={formulas} setFormulas={setFormulas} isReadonly={readonly} />;
          case 3:
            return (
            <AuditeeProofAnswerTable
              key={key}
              scores={scores}
              schedule={schedule}
              answer={answer}
              isReadonly={readonly} >
            </AuditeeProofAnswerTable>
            );
        }
      })}


      <Row style={{ justifyContent: 'flex-end' }}>
        <Col style={{ width: 'auto', flexGrow: 'unset', flexBasis: 'unset' }}>
          <Button
          onClick={handleSubmit}
          variant="success"
          // disabled={readonly}
          >Submit</Button>{' '}
        </Col>
      </Row>
      {/* <Spinner animation="border" role="status"></Spinner> */}
    </Container>
  )
}